/**
 * The wire contract between server and client.
 *
 * All timestamps cross the wire as ISO-8601 strings (`2026-07-15T14:30:00.000Z`).
 * All-day events are anchored to household-local midnight, with an EXCLUSIVE end
 * (matching iCal DTEND), so a single all-day event on the 4th is 4th→5th.
 */
/**
 * Member colours. Muted and slightly desaturated so they sit inside the amber-accented
 * palette without fighting it, and so they stay legible in BOTH themes — a neon chip that
 * pops on near-black turns invisible on white.
 */
export const MEMBER_COLORS = [
    '#d4a04a', // amber
    '#5b9cf6', // blue
    '#4caf7d', // green
    '#c586c0', // orchid
    '#e0764f', // rust
    '#4bb6b8', // teal
    '#b58ce0', // violet
    '#dc8a94', // rose
];
export const MEAL_SLOTS = ['breakfast', 'lunch', 'dinner'];
/**
 * The top level in a prestige cycle. Reaching it and filling the ring rolls over: the visible
 * level resets to 1 and the prestige count ticks up — Call-of-Duty style. Ten feels like a
 * milestone without being an eternity for a household ticking off chores.
 */
export const MAX_LEVEL = 10;
/**
 * Points for one full prestige cycle: enough to climb past MAX_LEVEL. Cost to reach level L is
 * 25·L·(L-1); the cycle is the cost of the level just beyond the cap, so within a cycle you pass
 * through levels 1…MAX_LEVEL and the final leg (10→prestige) is the ring filling at the top.
 */
export const PRESTIGE_POINTS = 25 * (MAX_LEVEL + 1) * MAX_LEVEL;
/**
 * Level + prestige from lifetime points. Cost to reach level L within a cycle is 25·L·(L-1), so
 * each level costs 50 more than the last (L2=50, L3=150, L4=300…) — fast early wins, a long tail.
 * Once a cycle's worth of points (`PRESTIGE_POINTS`) is banked, the level resets and `prestige`
 * increments; `atMax` marks the final climb where the ring fills toward the next prestige.
 */
export function levelForPoints(points) {
    const p = Math.max(0, Math.floor(points));
    const prestige = Math.floor(p / PRESTIGE_POINTS);
    const within = p - prestige * PRESTIGE_POINTS;
    const raw = Math.floor((1 + Math.sqrt(1 + 0.16 * within)) / 2);
    const level = Math.min(MAX_LEVEL, raw);
    const atMax = level >= MAX_LEVEL;
    const floor = 25 * level * (level - 1);
    const next = atMax ? PRESTIGE_POINTS : 25 * (level + 1) * level;
    const span = next - floor;
    const into = within - floor;
    return { level, prestige, floor, next, into, span, pct: span > 0 ? Math.min(1, into / span) : 0, atMax };
}
//# sourceMappingURL=index.js.map